module.exports = __webpack_public_path__ + "img/dx.be1fc62b.png";